<template>
	<div class="send-logs">
		<el-card>
			<div slot="header">
				<span>发送记录</span>
			</div>
			
			<el-table :data="logs" v-loading="loading" style="width: 100%">
				<el-table-column prop="subject" label="邮件主题" width="200">
					<template slot-scope="scope">
						{{ scope.row.subject || '无主题' }}
					</template>
				</el-table-column>
				
				<el-table-column prop="totalCount" label="总发送数" width="100" align="center">
					<template slot-scope="scope">
						<el-tag type="info">{{ scope.row.totalCount }}</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="successCount" label="成功数" width="100" align="center">
					<template slot-scope="scope">
						<el-tag type="success">{{ scope.row.successCount }}</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="failedCount" label="失败数" width="100" align="center">
					<template slot-scope="scope">
						<el-tag type="danger">{{ scope.row.failedCount }}</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="状态" width="160" align="center">
					<template slot-scope="scope">
						<template v-if="scope.row.status === 'pending'">
							<el-tag type="warning">待审核</el-tag>
						</template>
						<template v-else-if="scope.row.status === 'approved'">
							<el-tag type="success">已通过，等待发送</el-tag>
						</template>
						<template v-else-if="scope.row.status === 'sent'">
							<el-tag type="success">已发送</el-tag>
						</template>
						<template v-else-if="scope.row.status === 'rejected'">
							<el-tag type="danger">已拒绝</el-tag>
						</template>
						<template v-else-if="scope.row.status === 'send_failed'">
							<el-tag type="danger">发送失败</el-tag>
						</template>
						<template v-else>
							<el-tag type="info">{{ scope.row.status }}</el-tag>
						</template>
					</template>
				</el-table-column>
				
				<el-table-column prop="successRate" label="成功率" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="getSuccessRateType(scope.row)">
							{{ calculateSuccessRate(scope.row) }}
						</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="createdAt" label="发送时间" width="180">
					<template slot-scope="scope">
						{{ formatDate(scope.row.createdAt) }}
					</template>
				</el-table-column>
				
				<el-table-column label="操作" width="320">
					<template slot-scope="scope">
						<el-button size="mini" @click="viewDetails(scope.row)">查看详情</el-button>
						<el-button
							v-if="scope.row.status === 'rejected'"
							type="primary"
							size="mini"
							@click="reedit(scope.row)">重新编辑提交</el-button>
						<el-button
							v-if="scope.row.status === 'rejected'"
							size="mini"
							@click="resubmit(scope.row)">直接重新提交</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<div class="pagination-container">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</el-card>
		
		<!-- 详情对话框 -->
		<el-dialog title="发送详情" :visible.sync="detailsVisible" width="900px">
			<div v-if="selectedLog" class="details-content">
				<div class="detail-item">
					<strong>邮件主题：</strong>
					<span>{{ selectedLog.subject || '无主题' }}</span>
				</div>
				<div class="detail-item">
					<strong>邮件内容：</strong>
					<div class="content-preview">{{ selectedLog.content }}</div>
				</div>
				<div class="detail-item">
					<strong>发送统计：</strong>
					<div class="stats-grid">
						<div class="stat-box">
							<div class="stat-number">{{ selectedLog.totalCount }}</div>
							<div class="stat-label">总发送数</div>
						</div>
						<div class="stat-box success">
							<div class="stat-number">{{ selectedLog.successCount }}</div>
							<div class="stat-label">成功数</div>
						</div>
						<div class="stat-box danger">
							<div class="stat-number">{{ selectedLog.failedCount }}</div>
							<div class="stat-label">失败数</div>
						</div>
						<div class="stat-box">
							<div class="stat-number">{{ calculateSuccessRate(selectedLog) }}</div>
							<div class="stat-label">成功率</div>
						</div>
					</div>
				</div>
				<div class="detail-item">
					<strong>发送时间：</strong>
					<span>{{ formatDate(selectedLog.createdAt) }}</span>
				</div>
				<div class="detail-item" v-if="selectedLog.status !== 'pending'">
					<strong>审核时间：</strong>
					<span>{{ formatDate(selectedLog.reviewedAt) }}</span>
				</div>
				<div class="detail-item" v-if="selectedLog.reviewComment">
					<strong>审核意见：</strong>
					<div class="review-comment">{{ selectedLog.reviewComment }}</div>
				</div>

				<!-- 下载链接：图片 & 附件 -->
				<div class="detail-item" v-if="attachmentLinks.images && attachmentLinks.images.length">
					<strong>图片（可下载）：</strong>
					<div class="link-list">
						<a v-for="(img, i) in attachmentLinks.images" :key="'img-'+i" :href="img.url" :download="img.name">{{ img.name }} ({{ formatKB(img.size) }}KB)</a>
					</div>
				</div>
				<div class="detail-item" v-if="attachmentLinks.attachments && attachmentLinks.attachments.length">
					<strong>附件（可下载）：</strong>
					<div class="link-list">
						<a v-for="(att, i) in attachmentLinks.attachments" :key="'att-'+i" :href="att.url" :download="att.name">{{ att.name }} ({{ formatKB(att.size) }}KB)</a>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'SendLogs',
	data() {
		return {
			loading: false,
			logs: [],
			total: 0,
			pageSize: 10,
			currentPage: 1,
			selectedLog: null,
			detailsVisible: false,
			attachmentLinks: { images: [], attachments: [] }
		}
	},
	mounted() {
		this.loadLogs();
	},
	methods: {
		async loadLogs() {
			this.loading = true;
			try {
				const userId = this.$store.getters.userId;
				const response = await this.$http.get('/api/send-logs', {
					params: { 
						userId: userId,
						page: this.currentPage - 1,
						size: this.pageSize
					}
				});
				this.logs = response.data.content || response.data;
				this.total = response.data.totalElements || response.data.length;
			} catch (error) {
				// 一次轻量重试
				try {
					await new Promise(r => setTimeout(r, 500));
					const userId = this.$store.getters.userId;
					const response = await this.$http.get('/api/send-logs', {
						params: { userId, page: this.currentPage - 1, size: this.pageSize }
					});
					this.logs = response.data.content || response.data;
					this.total = response.data.totalElements || response.data.length;
					return;
				} catch (e) {}
				console.error('加载发送记录失败:', error);
				this.$message.error('加载发送记录失败');
			} finally {
				this.loading = false;
			}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.loadLogs();
		},
		
		handleCurrentChange(val) {
			this.currentPage = val;
			this.loadLogs();
		},
		
		async viewDetails(log) {
			this.selectedLog = log;
			this.detailsVisible = true;
			this.attachmentLinks = { images: [], attachments: [] };
			try {
				const { data } = await this.$http.get(`/api/send-logs/${log.id}/attachments/links`);
				this.attachmentLinks = data || { images: [], attachments: [] };
			} catch (e) {
				// ignore
			}
		},

		reedit(row) {
			this.$router.push({ name: 'SendEmail', query: { draftId: row.id } });
		},

		async resubmit(row) {
			try {
				const userId = this.$store.getters.userId;
				await this.$http.post(`/api/client/emails/${row.id}/resubmit`, null, { params: { userId } });
				this.$message.success('已重新提交审核');
				this.loadLogs();
			} catch (e) {
				this.$message.error('重新提交失败');
			}
		},
		
		calculateSuccessRate(log) {
			if (!log.totalCount || log.totalCount === 0) return '0%';
			const rate = (log.successCount / log.totalCount * 100).toFixed(1);
			return `${rate}%`;
		},
		
		getSuccessRateType(log) {
			const rate = this.calculateSuccessRate(log);
			const numRate = parseFloat(rate);
			if (numRate >= 90) return 'success';
			if (numRate >= 70) return 'warning';
			return 'danger';
		},
		
		formatDate(date) {
			if (!date) return '';
			return new Date(date).toLocaleString();
		},
		
		formatAttachmentsInfo(attachmentsInfo) {
			if (!attachmentsInfo) return '';
			try {
				const info = JSON.parse(attachmentsInfo);
				return JSON.stringify(info, null, 2);
			} catch (e) {
				return attachmentsInfo;
			}
		},

		formatKB(size) {
			if (!size || isNaN(size)) return 0;
			return (size / 1024).toFixed(1);
		}
	}
}
</script>

<style scoped>
.send-logs {
	padding: 20px;
}
.link-list a {
	margin-right: 12px;
}
</style> 